import { isWaypointClusteringEnabled } from '@/lib/waypoint-clustering'
import { error } from '@/lib/logger'
import tooltipCard from '@/assets/icons/tooltip-card.png'
import tooltipPill from '@/assets/icons/tooltip-pill.png'
import tooltipPillPointer from '@/assets/icons/tooltip-pill-pointer.png'
import clusterIcon from '@/assets/icons/waypoint-base/cluster-bg.png'
import { captureException } from '@sentry/vue'
import type { WebmapMapViewer } from '@/lib/map-x/webmap-viewer-types'

/**
 * Centralized error handler for image loading failures
 */
const imageErrorCallback = (
  err: Error | null | undefined,
  imageId: string
): void => {
  const errorMessage = `Failed to load ${imageId} image`
  error('Map', errorMessage, err)
  captureException(new Error(errorMessage), { tags: { map: 'map-x' } })
}

/**
 * *(AI-generated)*
 * Loads map images (tooltip pill, cards, cluster icons) into the map viewer after initialization.
 */
export const loadImages = (mapViewer: WebmapMapViewer): void => {
  // Load stretchable tooltip pill image
  mapViewer.addImage('tooltip_pill', tooltipPill, {
    stretchX: [[22, 66]],
    stretchY: [[13, 37]],
    content: [22, 13, 66, 37],
    pixelRatio: 2,
    onError: imageErrorCallback,
  })

  // Load stretchable tooltip pill pointer image
  mapViewer.addImage('tooltip_pill_pointer', tooltipPillPointer, {
    stretchX: [[22, 56]],
    stretchY: [[0, 30]],
    content: [22, 0, 56, 30],
    pixelRatio: 2,
    onError: imageErrorCallback,
  })

  // Load stretchable tooltip card image
  mapViewer.addImage('tooltip_card', tooltipCard, {
    stretchX: [[16, 137]],
    stretchY: [[0, 30]],
    content: [16, 4, 137, 28],
    pixelRatio: 2,
    onError: imageErrorCallback,
  })

  // Load waypoint cluster icon (SDF for recoloring)
  if (isWaypointClusteringEnabled.value) {
    mapViewer.addImage('cluster_icon', clusterIcon, {
      onError: imageErrorCallback,
    })
  }
}
